<template>
  <grid-container-fi :container="false">
    <div
      class="product-family-accordions-fi fi-col-start-1 fi-col-end-13 lg:fi-col-start-2 lg:fi-col-end-12"
    >
      <accordion-benefits-description-fi :catalog-data="catalogData" />
      <accordion-application-authorisation-fi :catalog-data="catalogData" />
      <accordion-assembly-instructions-fi :catalog-data="catalogData" />
      <accordion-document-downloads-fi :catalog-data="catalogData" />
    </div>
  </grid-container-fi>
</template>

<script setup lang="ts">
import setupAccordion from '@/components/atoms/accordion/setupAccordion';
import AccordionApplicationAuthorisationFi from '@/components/catalog-accordions/accordion-application-authorisation/AccordionApplicationAuthorisationFi.vue';
import AccordionAssemblyInstructionsFi from '@/components/catalog-accordions/accordion-assembly-instructions/AccordionAssemblyInstructionsFi.vue';
import AccordionBenefitsDescriptionFi from '@/components/catalog-accordions/accordion-benefits-description/AccordionBenefitsDescriptionFi.vue';
import AccordionDocumentDownloadsFi from '@/components/catalog-accordions/accordion-document-downloads/AccordionDocumentDownloadsFi.vue';
import GridContainerFi from '@/components/grid-fi/GridContainerFi.vue';

defineOptions({ name: 'ProductFamilyAccordionFi' });

withDefaults(
  defineProps<{
    catalogData?: Record<string, any>;
  }>(),
  {
    catalogData: () => ({}),
  },
);

setupAccordion();
</script>

<style src="./product-family-accordions-fi" />
